export const orders = {
    payment: {
        success: 'Покупка прошла успешно',
        success_service: 'Услуга {{service}} успешно оплачена',
        failed: 'Оплата не удалась',
    },
};
